import ExistingPortfolioSummaryV2 from '@master/model/kyc-form/existing-plans/v2/ExistingPortfolioSummary'
import CustomExistingPortfolioV2 from '@company-common/model/kyc-form/existing-plans/CustomExistingPortfolioV2'
import { Pointer } from '@master/annotation/Pointer'

export default class CustomExistingPortfolioSummary extends ExistingPortfolioSummaryV2 {
  @Pointer('ROOT', 'portfolios')
  portfolios: CustomExistingPortfolioV2[] = null
}
